module.exports = __webpack_public_path__ + "static/media/ProjectDeleteGraphics.b1a99854.png";